/**
 * Mobile Nav
 */
(function ($) {
  $(document).on("ready", function () {
    $("#mobileNav").on("click", function () {
      $(".mainNav, .lpNav").toggleClass("open");
      $(".mainNav .menu-item-has-children a").off("click");
      $(".mainNav .menu-item-has-children>a").on("click", function (e) {
        e.preventDefault();
        $(".mainNav li").removeClass("open");
        $(this).parent("li").addClass("open");
      });
    });
  });
})(window.jQuery);
